<template>
  <div>
    <div id="banner">
      <div class="slider-pro sp-horizontal" id="example1" style="width: 100%; max-width: 5200px">
        <div class="sp-slides">
          <div class="sp-slide">
            <a href="javascript:void(1)"><img
                class="sp-image"
                src="~@/assets/15011465791.png"
                alt=""
                title="" /></a>
          </div>
        </div>
      </div>
    </div>
    <div id="wrap_c">
      <div class="breadCrumb">
        <a href="/" tabindex="101" class="breadCrumb_no" title="首頁">首頁</a>
        <router-link :to="{name:'工作環境'}"><span>人才招募</span></router-link>
        <router-link :to="{name:'加入白金'}"><span>加入白金</span></router-link>
      </div>


      <h2 class="titleA">
        加入白金
      </h2>
      <div id="page_left">
        <div id="menu_out">
          <div id="menu_c">
            <ul class="m_top"></ul>
            <li>
              <router-link :to="{name:'工作環境'}" class="menu_on0">幸福白金</router-link>
              <span style="cursor:hand" class="arrow_class_open"
                onclick="allshow_show_menu2(this,'1950','http://www.ptotinc.com/','0','','1951')">
                <img src="@/assets/folder_open.png" id="img_son_menu_1950" class="class_sonimg_0">
              </span>
            </li>
            <div id="son_menu_1950" class="class_sondiv_0" style="display:none">
              <ol>
                <router-link :to="{name:'工作環境'}" class="menu_on0">工作環境</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'餐廳環境'}" class="menu_on0">餐廳環境</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'籃球社'}" class="menu_on0">籃球社</router-link>
              </ol>

              <ol>
                <router-link :to="{name:'瑜珈社'}" class="menu_on0">瑜珈社</router-link>
              </ol>

            </div>
            <li>
              <router-link :to="{name:'加入白金'}" class="menu_on">加入白金</router-link>
            </li>
          </div>
        </div>
      </div>

      <div id="page_right_no">
        <!--###右側欄區塊###-->
      </div>

      <div id="page_main_2">
        <!--###內頁中間內容區塊###-->
        <div class="cC">

          <form method="POST" action="portal_c2_cnt.php?owner_num=c2_34776&button_num=c2&folder_id=1951&search_type=1">

            <div class="searchbar">
              <ul>
                <li>

                  尋找：

                  <select tabindex="62" name="search_field">
                    <option value="all_field">全部</option>
                    <option value="text_field_0">標題</option>
                  </select>
                  <input tabindex="63" name="search_word" type="text" class="input" value="" />
                  <input tabindex="64" name="search_b1" type="submit" class="btn" value="查詢" />
                  <!--<input name="Submit3" type="button" class="btn2" value="進階查詢" onclick="location.href='http://www.ptotinc.com/member/ptotinc/portal_c2_cnt.php?owner_num=c2_34776&button_num=c2&folder_id=1951&search_type=2';"/>-->
                </li>
              </ul>
            </div>
          </form>

          <div class="cate_info"> <span style="font-size:18px;">一、基本福利</span>
            <ol>
              <li><span style="font-size:15px;">健康保險</span></li>
              <li><span style="font-size:15px;">勞工保險</span></li>
              <li><span style="font-size:15px;">退休金提撥</span></li>
            </ol>
            <span style="font-size:15px;">&nbsp;<br />
              <span style="font-size:18px;">二、出勤/休假</span></span>

            <ol>
              <li><span style="font-size:15px;">間接人員彈性工作時間</span></li>
              <li><span style="font-size:15px;">產假二個月，優於法令56天</span></li>
            </ol>
            <span style="font-size:15px;">&nbsp;<br />
              <span style="font-size:18px;">三、薪資/獎金</span></span>

            <ol>
              <li><span style="font-size:15px;">年終獎金：每年視營運狀況及個人績效享年終獎金</span></li>
              <li><span style="font-size:15px;">盈餘分紅：除年終獎金外，每年視營運狀況及個人績效享有盈餘分紅</span></li>
              <li><span style="font-size:15px;">依個人績效年度調薪及晉升</span></li>
              <li><span style="font-size:15px;">津貼︰各式津貼(中夜班津貼、技能技津貼、工作環境津貼、輪班津貼&hellip;.等)</span></li>
              <li><span style="font-size:15px;">依營運狀況及個人績效直接人員每月發放激勵獎金1000~3000元</span></li>
              <li><span style="font-size:15px;">介紹獎金</span></li>
              <li><span style="font-size:15px;">專利提案獎金</span></li>
              <li><span style="font-size:15px;">提案改善獎金</span></li>
              <li><span style="font-size:15px;">資深員工獎金及紀念獎座</span></li>
            </ol>
            <span style="font-size:15px;">&nbsp;<br />
              <span style="font-size:18px;">四、禮金/補助</span></span>

            <ol>
              <li><span style="font-size:15px;">端午禮金</span></li>
              <li><span style="font-size:15px;">中秋禮金</span></li>
              <li><span style="font-size:15px;">生日禮金</span></li>
              <li><span style="font-size:15px;">結婚禮金</span></li>
              <li><span style="font-size:15px;">生育禮金</span></li>
              <li><span style="font-size:15px;">喪葬慰問金</span></li>
              <li><span style="font-size:15px;">員工每年旅遊補助</span></li>
              <li><span style="font-size:15px;">特約商店購物及用餐折扣</span></li>
            </ol>
            <span style="font-size:15px;">&nbsp;<br />
              <span style="font-size:18px;">五、員工活動</span></span>

            <ol>
              <li><span style="font-size:15px;">社團活動︰藍球社、瑜珈社&hellip;.等。</span></li>
              <li><span style="font-size:15px;">節目精彩、獎金、獎品豐富的年終旺年晚會</span></li>
            </ol>
            <span style="font-size:15px;">&nbsp;<br />
              <span style="font-size:18px;">六、設施設備</span></span>

            <ol>
              <li><span style="font-size:15px;">設有員工免費汽、機車停車場</span></li>
              <li><span style="font-size:15px;">用餐補助及多樣化的用餐選擇</span></li>
              <li><span style="font-size:15px;">完善哺乳室</span></li>
            </ol>
            <br />
            <span style="font-size:15px;"><span style="font-size:18px;">七、健康促進︰</span></span>

            <ol>
              <li><span style="font-size:15px;">完善醫務室，配置專業廠護協助員工身心健康</span></li>
              <li><span style="font-size:15px;">定期廠醫駐廠問診</span></li>
            </ol>
            <br />
            <br />
            <br />
            <a href="https://goo.gl/GuAzm4" target="_blank"><input class="s631_join_input" type="submit"
                value="查詢職缺" /></a><br />
            <!--<br />
            <iframe allowfullscreen="" frameborder="0" height="450"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.5370454001636!2d121.37720781487542!3d25.049780543812904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34681e8a16fb59b3%3A0xc476fd931c816ee!2zMzMz5qGD5ZyS5biC6b6c5bGx5Y2A56eR5oqA5LqM6LevMzfomZ8!5e0!3m2!1szh-TW!2stw!4v1500358916103"
              style="border:0" width="100%"></iframe>
              -->
          </div>

          <ul id="c_list">
          </ul>

          <br><br>
          <p style="text-align:center;">
          </p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'recruit',
  data () {
    return {
      isAboutPage: true
    }
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', 'about'); // about/ product/ recruit/ contactus
  },
  methods: {
    init: function () {
      $('#rwd_nav').pageslide({
          modal: true
      });
      $('.sp-selected .sp-font span').addClass('animated fadeInLeft');
      $('.sp-selected .sp-font2').addClass('animated fadeInRight');
      $('#example1').sliderPro({
          keyboardOnlyOnFocus: true,
          set_swipe: '1',
          width: '5120',
          height: '1280',
          autoplay: true,
          waitForLayers: true,
          autoScaleLayers: false,
          fade: true,
          autoplayDelay: 5000,
          arrows: false,
          buttons: false,
          breakpoints: {
            1024: {
              forceSize: '',
              width: '1024',
              height: '256'
            }
          }
      });
      sliderPro_add_title('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@');
      // initVideo();
    }
  }
}
</script>
<style src='@/assets/css/15347449502.css'>
</style>


// WEBPACK FOOTER //
// src/components/joinus/Recruit.vue